(function () {
  // Because this goes through Shopify's App Proxy, the URL is on the
  // SAME domain as the store, so no CORS setup is needed here.
  const API_BASE = '/apps/wishlist';
  let wishlistIds = new Set();

  async function loadWishlist() {
    try {
      const res = await fetch(`${API_BASE}/list`, { credentials: 'same-origin' });
      if (!res.ok) return; // e.g. guest visitor, just leave icons unfilled
      const data = await res.json();
      wishlistIds = new Set((data.product_ids || []).map(String));
      updateAllIcons();
    } catch (e) {
      console.error('Wishlist load failed', e);
    }
  }

  function updateAllIcons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const pid = btn.getAttribute('data-product-id');
      const active = wishlistIds.has(pid);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateHeaderCount();
  }

  function updateHeaderCount() {
    const bubble = document.querySelector('.wishlist-count-bubble');
    if (!bubble) return;
    const count = wishlistIds.size;
    const countSpan = bubble.querySelector('[aria-hidden="true"]');
    if (countSpan) countSpan.textContent = count;
    if (count > 0) {
      bubble.hidden = false;
    } else {
      bubble.hidden = true;
    }
  }

  async function toggleWishlist(productId, productHandle, btn) {
    if (btn.disabled) return;
    btn.disabled = true;

    const wasActive = wishlistIds.has(productId);
    // optimistic UI: flip immediately, revert later if the request fails
    btn.classList.toggle('is-active', !wasActive);
    btn.setAttribute('aria-pressed', (!wasActive).toString());

    try {
      const res = await fetch(`${API_BASE}/toggle`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId, product_handle: productHandle }),
      });
      if (!res.ok) throw new Error('request failed: ' + res.status);
      const data = await res.json();

      if (data.status === 'added') wishlistIds.add(productId);
      if (data.status === 'removed') wishlistIds.delete(productId);
      updateAllIcons();

      document.dispatchEvent(
        new CustomEvent('wishlist:toggled', {
          detail: { status: data.status, productId, btn },
        })
      );
    } catch (e) {
      console.error('Wishlist toggle failed', e);
      // revert optimistic change
      btn.classList.toggle('is-active', wasActive);
      btn.setAttribute('aria-pressed', wasActive.toString());
    } finally {
      btn.disabled = false;
    }
  }

  window.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleWishlist(
        btn.getAttribute('data-product-id'),
        btn.getAttribute('data-product-handle'),
        btn
      );
    },
    true // capture phase on WINDOW: fires before any document-level capture listeners
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadWishlist);
  } else {
    loadWishlist();
  }
})();